import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      redirect: 'upload'
    },
    // 首页
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index/index')
    },
    // 登录 
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index')
    },
    //上传文件 
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/upload/index')
    },
    // 即时翻译
    {
      path: '/conversion',
      name: 'conversion',
      component: () => import('@/views/conversion/index')
    },
    //历史记录 
    {
      path: '/history',
      name: 'history',
      component: () => import('@/views/history/index')
    },
    // 术语词典
    {
      path: '/term',
      name: 'term',
      component: () => import('@/views/term/index')
    },
    {
      path: '/term-detail',
      name: 'term-detail',
      component: () => import('@/views/term-detail/index')
    },
    //预览模式 
    {
      path: '/preview',
      name: 'preview',
      component: () => import('@/views/preview/html')
    },
    //预览模式 
    {
      path: '/arxiv',
      name: 'arxiv',
      // component: () => import('@/views/arxiv/index')
      component: () => import('@/views/previewArxiv/html')
    },
    {
      path: '/previewArxiv',
      name: 'previewArxiv',
      component: () => import('@/views/previewArxiv/html')
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('@/views/demo/html')
    },

    //预览模式 
    {
      path: '/preview_pic',
      name: 'preview_pic',
      component: () => import('@/views/preview/index')
    },
    //在线翻译 
    {
      path: '/filePreview',
      name: 'filePreview',
      component: () => import('@/views/filePreview/index')
    },
    //关于我们 
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index')
    },
    // 帮助 
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/help/index')
    },
    // 服务器维护页面 
    {
      path: '/maintain',
      name: 'maintain',
      component: () => import('@/views/maintain/index')
    },
    // 个人空间页面
    {

      path: '/personal',
      name: 'personal',
      component: () => import('@/views/personal/index')
    },
    {

      path: '/setUp',
      name: 'setUp',
      component: () => import('@/views/setUp/index')
    },
    // 测试页面
    {
      path: '/text',
      name: 'text',
      component: () => import('@/views/preview/text')
    },
    // 分屏的测试页面
    {
      path: '/splitScreen',
      name: 'splitScreen',
      component: () => import('@/views/preview/splitScreen')
    },
    // 分屏的测试页面
    {
      path: '/splitScreen2',
      name: 'splitScreen2',
      component: () => import('@/views/preview/splitScreen2')
    },
    // 分屏的测试页面
    {
      path: '/splitScreen3',
      name: 'splitScreen3',
      component: () => import('@/views/preview/splitScreen3')
    },
    // 青梨跳转过度页
    {
      path: '/transition',
      name: 'transition',
      component: () => import('@/views/transition/index')
    },
    //404页面
    {
      path: '*',
      name: '404',
      component: () => import('@/views/404/index')
    }
  ]
})
router.beforeEach((to, from, next) => {
  //   
  console.log(to.path)
  if (to.path == '/demo' || to.path == '/arxiv' || to.path == '/previewArxiv') {
    next()
  } else if (to.path !== '/login' && to.path !== '/transition' && !JSON.parse(window.localStorage.getItem("usid"))) {
    // 用户未登录跳转到登录页面
    return next('/login')
  } else {
    next()

  }
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js